import { useDispatch, useSelector } from "react-redux"
import { changeStatus, onSetSelectedCategory, onSetSelectedCustomer, onSetSelectedPriceList, onSetSelectedSalesman, onSetSelectedSubCategory, selectSearcherState, onSetSelectedSpecificAttribute, onSetSelectedUseAttribute, onSetDataSearch, onSetFilterProducts, onSetSelectedAddress } from "../redux/slices/searcherSlice"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { ApiStatus } from "../types/api/status"
import { SearchProductsAPI } from "../apis/SearchProductsAPI"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { Subcategory } from "../types/slices/subcategoryType"
import { SpecificAttribute } from "../types/slices/specificAttributesType"
import { ProductAttribute } from "../types/slices/productAttributesType"
import { FilterProducts } from "../types/slices/searcherType"
import { ClientAdress } from "../types/slices/clientAdressType"

export const useSearcherStore = () => {

    const dispatch = useDispatch()
    const { selectedCustomer, status, selectedCategory, selectedPriceList, selectedSalesman,
        selectedSubCategory, selectedSpecificAttribute, selectedUseAttribute, dataSearch,
        filterProducts, selectedAddress } = useSelector(selectSearcherState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getSearchProducts = async (data?: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SearchProductsAPI.getSearchProducts(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail, total } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return { detail, total }
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getFilterProducts = async (data: {}) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SearchProductsAPI.getFilterProducts({ ...data, idcompany })
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedCustomer = (customer: any) => {
        try {
            dispatch(onSetSelectedCustomer(customer))
        } catch (error) {
            console.log(error)
        }
    }

    const setSelectedSalesman = (salesman: any) => {
        try {
            dispatch(onSetSelectedSalesman(salesman))
        } catch (error) {
            console.log(error)
        }
    }

    const setPricelistName = (priceList: any) => {
        try {
            dispatch(onSetSelectedPriceList(priceList))
        } catch (error) {
            console.log(error)
        }
    }

    const setSelectedCategorySearcher = (category: any) => {
        try {
            dispatch(onSetSelectedCategory(category))
        } catch (error) {
            console.log(error)
        }
    }

    const setSelectedSubCategory = (subCategory: Subcategory | null) => {
        try {
            dispatch(onSetSelectedSubCategory(subCategory))
        } catch (error) {
            console.log(error)
        }
    }

    const setSelectedSpecificAttribute = (specificAttribute: SpecificAttribute) => {
        try {
            dispatch(onSetSelectedSpecificAttribute(specificAttribute))
        } catch (error) {
            console.log(error)
        }
    }

    const setSelectedUseAttribute = (attribute: ProductAttribute) => {
        try {
            dispatch(onSetSelectedUseAttribute(attribute))
        } catch (error) {
            console.log(error)
        }
    }

    const setDataSearch = (data: any[]) => {
        try {
            dispatch(onSetDataSearch(data))
        } catch (error) {
            console.log(error)
        }
    }

    const setFilterProducts = (data: FilterProducts) => {
        try {
            dispatch(onSetFilterProducts(data))
        } catch (error) {
            console.log(error)
        }
    }

    const setSelectedAddress = (data: ClientAdress | null) => {
        try {
            dispatch(onSetSelectedAddress(data))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        status,
        selectedCustomer,
        selectedSalesman,
        selectedPriceList,
        selectedCategory,
        selectedSubCategory,
        selectedSpecificAttribute,
        selectedUseAttribute,
        dataSearch,
        filterProducts,
        selectedAddress,
        setSelectedCustomer,
        setSelectedSalesman,
        setPricelistName,
        setSelectedCategorySearcher,
        setSelectedSubCategory,
        setSelectedSpecificAttribute,
        setSelectedUseAttribute,
        getSearchProducts,
        getFilterProducts,
        setDataSearch,
        setFilterProducts,
        setSelectedAddress
    }
}